import { FC, memo, useEffect, useMemo, useRef, useState } from 'react';
import { useSpring, animated, easings, useTransition } from "@react-spring/web";
import { Image } from '@shuwen/wenlv-web-activity-library';
import { randomSize } from './instance';
import { Biz_Info } from "@/store/types";
import { getAssetUrl } from '@/utils/common';
import { useStore } from '@/store';
import styles from './index.module.scss';
import { FlagImage } from '@/components/common/FlagImage';
import Card from './components/Card';
import CustomScroll from './components/CustomScroll';
import BackgroundAnimate from '@/components/BackgroundAnimate';
import { characterImgs } from './instance';
import { getTargetList } from '@/services/api';
import { useQueryGetAllRouteData } from '@/services/hooks';
import QrCode from '@/components/QrCode';
import { driveDigitalHumanByText } from '@/pages/DigitalHuman/util/tts-manage';

const CharaterTimeLine: FC = () => {
  const routeTimeLineDetailId = useStore((state) => state.routeTimeLineDetailId);
  // const mode = useStore((state) => state.mode);
  const timelineRef = useRef<any>();
  const bgRef = useRef<any>();

  const [bgWidth, setBgWidth] = useState(0);
  const [list, setList] = useState([]);

  const { data } = useQueryGetAllRouteData();

  const characterRoutePlaceDetail = useMemo(() => {
    let detail = data?.charaterList.find((item: any) => item.entity_id === routeTimeLineDetailId);
    if (!detail) {
      detail = data?.themeList.find((item: any) => item.entity_id === routeTimeLineDetailId);
    }
    return detail;
  }, [data, routeTimeLineDetailId]);



  // 语音控制
  useEffect(()=>{
    if(!routeTimeLineDetailId)return;
    let detail = data?.charaterList.find((item: any) => item.entity_id === routeTimeLineDetailId);
    if(detail){
      driveDigitalHumanByText(`我们现在看到的是${detail.name}文学路线详情`);
    }else{
      detail = data?.themeList.find((item: any) => item.entity_id === routeTimeLineDetailId);
      if(detail){
        driveDigitalHumanByText(`我们现在看到的是${detail.name}主题路线详情`);
      }else{
        driveDigitalHumanByText('未找到相关路线');
      }
    }
  },[data,routeTimeLineDetailId])


  const character = useMemo(() => {
    if (characterRoutePlaceDetail?.content && characterRoutePlaceDetail.content?.includes('\n')) {
      const name = characterRoutePlaceDetail.content.split('\n')[0];
      const target = characterImgs.find(i => i.name === name);
      if (target) {
        return {
          ...target,
          theme: characterRoutePlaceDetail.name,
          summary: characterRoutePlaceDetail.summary
        }
      }
    } else {
      return {
        name: '',
        image: '',
        width: 0,
        left: 0,
        theme: characterRoutePlaceDetail?.name || '',
        summary: characterRoutePlaceDetail?.summary || ''
      }
    }
  }, [characterRoutePlaceDetail]);



  // console.log('characterRoutePlaceDetail', characterRoutePlaceDetail);

  useEffect(() => {
    if (characterRoutePlaceDetail?.biz_info) {
      const { biz_info,tags } = characterRoutePlaceDetail;
      getList(biz_info,tags);
    } else {
      setList([]);
    }
  }, [characterRoutePlaceDetail]);

  useEffect(function () {
    if (bgRef.current) {
      setBgWidth(bgRef.current?.getBoundingClientRect()?.width);
    }
  }, [characterRoutePlaceDetail, bgRef.current]);

  const [scrollBgAnimation, bgAnime] = useSpring(
    () => ({
      from: { transform: "translateX(-50%)" },
      to: { transform: "translateX(0%)" },
      config: {
        duration: bgWidth / 0.05, // 滚动时间，可以根据需要调整
        easing: easings.linear,
      },
      reset: true, // 重新开始动画
      loop: true, // 无限循环
    }),
    [bgWidth]
  );

  const transitions = useTransition(characterRoutePlaceDetail, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 500 },
  });

  const getList = (biz_info: Biz_Info,tags:string[]) => {
    let str = '';
    biz_info.data.forEach((i) => {
      if (str) {
        str += ` OR entity_id:${i.id}`;
      } else {
        str += `entity_id:${i.id}`;
      }
    });
    getTargetList(str).then((res: any) => {
      if (res?.length) {
        const arr: any = biz_info.data.map((item, index) => {
          const target = res.find((i: any) => i.entity_id === item.id);
          const newExtNeighborList = target?.ext_neighborList?.filter((i: any) => {
            return tags.some((tag: string) => {
              const hasTag = i.edge?.tags?.includes(tag);
              const isRouteEntity = tag.startsWith('路线实体');
              return hasTag && isRouteEntity;
            });
          });
          // console.log('newExtNeighborList',newExtNeighborList);
          if (target) {
            return {
              ...target,
              ext_neighborList: newExtNeighborList,
              name: item.name,
              order: item?.order,
              time_order: item?.time_order,
              size: randomSize[index]
            }
          } else {
            return null;
          }

        }).filter((i) => i).sort((a: any, b: any) => b.time_order - a.time_order);
        arr.push(null);
        setList(arr);
      } else {
        setList([]);
      }
    });
  }

  return (
    <>
      {
        transitions((style, item) =>
          item ?
            <animated.div style={style}>
              <div 
              className={styles.charaterTimeLine}
              style={{
                backgroundImage: getAssetUrl('images/route/timeLine/timeLineBg.png', 'url')
              }}
              >
                <div className={styles.mask} />
                {/* <Image src={getAssetUrl('images/route/timeLine/bgIcon.png')} className={styles.mask2} /> */}
                <BackgroundAnimate visible={true} animate={true} loop>

                </BackgroundAnimate>
                <div className={styles.content}>
                  <animated.div
                    className={styles.mountainBg}
                    style={scrollBgAnimation}
                    ref={bgRef}
                  >
                    <div
                      className={styles.bg}
                      style={{ backgroundImage: getAssetUrl("images/route/timeLine/山.png", "url") }}
                    ></div>
                    <div
                      className={styles.bg}
                      style={{ backgroundImage: getAssetUrl("images/route/timeLine/山.png", "url") }}
                    ></div>
                    <div
                      className={styles.bg}
                      style={{ backgroundImage: getAssetUrl("images/route/timeLine/山.png", "url") }}
                    ></div>
                    <div
                      className={styles.bg}
                      style={{ backgroundImage: getAssetUrl("images/route/timeLine/山.png", "url") }}
                    ></div>
                  </animated.div>
                  <animated.div className={styles.riverBg} style={scrollBgAnimation}>
                    <div className={styles.bg}>
                      <FlagImage src={getAssetUrl("images/route/timeLine/水.png")}></FlagImage>
                    </div>
                    <div className={styles.bg}>
                      <FlagImage src={getAssetUrl("images/route/timeLine/水.png")}></FlagImage>
                    </div>
                    <div className={styles.bg}>
                      <FlagImage src={getAssetUrl("images/route/timeLine/水.png")}></FlagImage>
                    </div>
                    <div className={styles.bg}>
                      <FlagImage src={getAssetUrl("images/route/timeLine/水.png")}></FlagImage>
                    </div>
                  </animated.div>
                  {
                    list?.length ?
                      <div className={styles.timeLine}>
                        <CustomScroll>
                          {
                            list.map((item, index) => (
                              index === list.length - 1 ?
                                <div
                                  key={index}
                                  style={{
                                    width: 300,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <Image
                                    src={getAssetUrl('images/route/timeLine/timeIcon.png')}
                                    style={{ marginTop: 152 }}
                                  />
                                </div> :
                                <Card size={item} key={index} index={index} />
                            ))
                          }
                        </CustomScroll>
                      </div> :
                      null
                  }
                </div>
                <div className={styles.leftMask} />
                {
                  character ? <div className={styles.theme}>
                    {
                      character.image && character.name ?
                        <>
                          <Image
                            src={character.image}
                            className={styles.image}
                            style={{ width: character.width, left: character.left }}
                          />
                          <div className={styles.author}>{character.name}</div>
                        </> :
                        null
                    }
                    {/* <div className={styles.pinyin}>{'HANZHOU\nWESTLAKE'}</div> */}
                    <img src={getAssetUrl('images/route/timeLine/pinyin.svg')} className={styles.pinyin} />
                    <div
                      className={styles.title}
                      style={{ fontSize: character?.theme.length > 4 ? 70 : '' }}>
                      {character.theme}
                    </div>
                    <div className={styles.summary}>{character.summary}</div>
                  </div> : null
                }
                <QrCode name={character?.theme} />
              </div>
            </animated.div> :
            null
        )
      }
    </>
  )

  // return characterRoutePlaceDetail && (
  //   <BackgroundAnimate visible={true} animate={false} className={styles.charaterTimeLine}>

  //   </BackgroundAnimate>
  // )
}

export default memo(CharaterTimeLine);